/*
 * @Author: Fan
 * @Date: 2020-04-26 12:13:42
 * @description:
 * @LastEditors: Fan
 */
import Rate from "./Rate";
import RateEX from "./RateEx";
import BigAttachment from "./BigAttachment";
export default [Rate, RateEX, BigAttachment];
